import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = props => {
    const {
        loading,
        children,
        size = 30,
        staticOnly,
        marginTop = 3,
        showChildren = false,
        color,
        forceStop,
        ...rest
    } = props;

    if (!forceStop && (loading || !children || staticOnly))
        return (
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                mt={marginTop}
                {...rest}
            >
                <CircularProgress size={size} color={color} />
                {showChildren && !staticOnly && children}
            </Box>
        );

    return children;
};

Loader.propTypes = {
    loading: PropTypes.bool,
    staticOnly: PropTypes.bool,
    showChildren: PropTypes.bool,
    forceStop: PropTypes.bool,
    children: PropTypes.node,
    size: PropTypes.number,
    color: PropTypes.oneOf(['primary', 'secondary', 'inherit']),
    marginTop: PropTypes.number,
};

export default Loader;
